import React from "react"
import { Box } from "@material-ui/core"

export default function BlankDivider({ dividerSize }) {
  return <Box component="div" display="block" pb={dividerSize} />
}
